import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getCrmToken() {
  return localStorage.getItem("noxway_crm_token") || "";
}

export function setCrmToken(token) {
  localStorage.setItem("noxway_crm_token", token);
}

export function clearCrmToken() {
  localStorage.removeItem("noxway_crm_token");
}

export async function crmApi(path, { method = "GET", body, params } = {}) {
  try {
    const { data } = await axios({
      url: `${API}/crm${path}`,
      method,
      data: body,
      params,
      headers: { Authorization: `Bearer ${getCrmToken()}` },
    });
    return data;
  } catch (e) {
    if (e.response?.status === 401) {
      clearCrmToken();
      window.location.reload();
    }
    throw e;
  }
}

export function getCrmProfile() {
  try {
    return JSON.parse(localStorage.getItem("noxway_crm_profile")) || null;
  } catch {
    return null;
  }
}

export async function crmUnlock({ key, email, password, totp }) {
  const { data } = await axios.post(`${API}/crm/unlock`, {
    key: key || undefined,
    email: email || undefined,
    password: password || undefined,
    totp: totp || undefined,
  });
  setCrmToken(data.token);
  localStorage.setItem("noxway_crm_profile", JSON.stringify({ name: data.name, role: data.role }));
  return data;
}

export function crmLogout() {
  clearCrmToken();
  localStorage.removeItem("noxway_crm_profile");
}
